<template>
  <div>
    <div class="chart-operator">
	  <h2>
		{{$t('label.notCallSummaryTitle')}}
	  </h2>
      <div class="wrap-chart">
        <apexchart ref="chart1" type="bar" :options="chartOptions" :series="series"></apexchart >
      </div>
	</div>
    <div class="data-section">
		<h2>
		  {{$t('label.titleDataManager')}}
		</h2>
		<div class="d-flex mb-2">
		  <b-button v-on:click="loadAddNew()" class="float-right" variant="outline-success"><i class="fa fa-plus"></i> {{$t('label.addNewData')}}</b-button>
		</div>
		<b-table striped bordered head-variant="dark" hover :items="dataTable" :dark="dark" :fields="fields" responsive>
		  <template #cell(name)="data">
			  <span :class="data.item.status == 0 ? 'no-active' : 'active'">{{data.item.name}}</span>
		  </template>
		  <template #cell(action)="data">
			  <a href="javascript:void(0)" v-on:click="editData(data.item.id)" style="color: blue">{{$t('label.edit')}}</a>
		  </template>
      <template #cell(notPick)="data">
        <div class="row text-center">
          <div class="col-lg-4 col-md-4 col-xs-12">{{data.item.notPick}}</div>
          <div class="col-lg-8 col-md-8 col-xs-12" v-if="data.item.notPick > 0">
            <b-button size="sm" variant="success" @click="openConvertToNotCall(data.item.id)">
              <i class="fa fa-refresh" aria-hidden="true"></i>
              {{$t('label.convertToNotCall')}}
            </b-button>
          </div>
        </div>
      </template>
		</b-table>
	</div>
	<div class="product-section">
		<h2>
		  {{$t('label.productSectionTitle')}}
		</h2>
		<div class="d-flex mb-2">
		  <b-button v-on:click="loadAddNewProduct()" class="float-right" variant="outline-success"><i class="fa fa-plus"></i> {{$t('label.addNewProduct')}}</b-button>
		</div>
		<b-table striped bordered head-variant="dark" hover :items="dataTableProduct" :dark="dark" :fields="productFields" responsive>
		  <template #cell(status)="data">
			<span :class="data.item.status == 0 ? 'no-active' : 'active'">{{ optionsStatus.filter(function (item) {
                   return item.value == data.item.status
                 })[0].text
			  }}</span>
		  </template>
		  <template #cell(price)="data">
				<span>{{data.item.price.toLocaleString() + $currency}}</span>
		  </template>
		  <template #cell(action)="data">
			<a href="javascript:void(0)" v-on:click="editProduct(data.item.id)" style="color: blue">{{$t('label.edit')}}</a> |
			<a href="javascript:void(0)" v-on:click="openDeleteProductModal(data.item.id)" style="color: blue">{{$t('label.delete')}}</a>
		  </template>
		</b-table>
	</div>

	  <b-modal ref="modal-scoped" size="lg" class="modal-aeg">
	  <template #modal-header="{ close }">
		<h5 class="mb-0">{{$t('label.addNewData')}}</h5>
	  </template>
	  <template>
		<div class="row">
		  <div class="col-md-6">
			<label class="require">{{$t('label.dataName')}}</label>
			<b-form-input required v-model="dataNew.dataName" :placeholder="$t('label.dataName')">
			</b-form-input>
			<div class="error-message w-100 clear text-left">
			  {{ msg['dataName'] ? msg['dataName'][0] : ''  }}
			</div>
		  </div>
		  <div class="col-md-6">
			<label class="require">{{$t('label.status')}}</label>
			<b-form-select v-model="dataNew.status" :options="optionsStatus"></b-form-select>
			<div class="error-message w-100 clear text-left">
			  {{ msg['status'] ? msg['status'][0] : ''  }}
			</div>
		  </div>
		</div>
	  </template>
	  <template #modal-footer class="text-center">
		<b-button size="sm" variant="danger" @click="cancel()">
		  <i class="fa fa-times-circle" aria-hidden="true"></i>
		  {{$t('label.cancel')}}
		</b-button>
		<b-button size="sm" variant="success" @click="insertData()">
		  <i class="fa fa-check" aria-hidden="true"></i>
		  {{$t('label.save')}}
		</b-button>

	  </template>
	</b-modal>
	<b-modal ref="modal-scoped-edit" size="lg" class="modal-aeg">
	  <template #modal-header="{ close }">
		<h5 class="mb-0">{{$t('label.updateLabelData')}}</h5>
	  </template>
	  <template>
		<div class="row">
		  <div class="col-md-6">
			<label class="require">{{$t('label.dataName')}}</label>
			<b-form-input required v-model="dataUpdate.name">
			</b-form-input>
			<div class="error-message w-100 clear text-left">
			  {{ msg['name'] ? msg['name'][0] : ''  }}
			</div>
			<label class="require mt-2">{{$t('label.assignedUser')}}</label>
			<b-form-select v-model="dataUpdate.sale_id" multiple :options="optionsUser"></b-form-select>
			<div class="error-message w-100 clear text-left">
			  {{ msg['saleId'] ? msg['saleId'][0] : ''  }}
			</div>
		  </div>
		  <div class="col-md-6">
			<label>{{$t('label.status')}}</label>
			<b-form-select v-model="dataUpdate.status" :options="optionsStatus"></b-form-select>
			<div class="error-message w-100 clear text-left">
			  {{ msg['status'] ? msg['status'][0] : ''  }}
			</div>
		  </div>
		</div>
	  </template>
	  <template #modal-footer class="text-center">
		<b-button size="sm" variant="danger" @click="cancel()">
		  <i class="fa fa-times-circle" aria-hidden="true"></i>
		  {{$t('label.cancel')}}
		</b-button>
		<b-button size="sm" variant="success" @click="updateData()">
		  <i class="fa fa-check" aria-hidden="true"></i>
		  {{$t('label.label')}}
		</b-button>
	  </template>
	</b-modal>
    <b-modal ref="modal-scoped-product" size="lg" class="modal-aeg">
      <template #modal-header="{ close }">
        <h5 class="mb-0">{{$t('label.addNewProduct')}}</h5>
      </template>
      <template>
        <div class="row">
          <div class="col-md-6">
            <label class="require">{{$t('label.productName')}}</label>
            <b-form-input size="md" required v-model="productNew.productName" :placeholder="$t('label.productName')">
            </b-form-input>
            <div class="error-message w-100 clear text-left">
              {{ msg['productName'] ? msg['productName'][0] : ''  }}
            </div>
            <label class="require mt-2">{{$t('label.quantity')}}</label>
            <b-form-input size="md" type="number" required v-model="productNew.quantity">
            </b-form-input>
            <div class="error-message w-100 clear text-left">
              {{ msg['quantity'] ? msg['quantity'][0] : ''  }}
            </div>
            <label class="mt-2">{{$t('label.description')}}</label>
            <b-form-input size="md" type="text" v-model="productNew.description">
            </b-form-input>
          </div>
          <div class="col-md-6">
            <label class="require">{{$t('label.status')}}</label>
            <b-form-select size="md" v-model="productNew.status" :options="optionsStatus"></b-form-select>
            <div class="error-message w-100 clear text-left">
              {{ msg['status'] ? msg['status'][0] : ''  }}
            </div>
            <label class="require mt-2">{{$t('label.price')}}</label>
            <b-form-input size="md" type="number" required v-model="productNew.price">
            </b-form-input>
            <div class="error-message w-100 clear text-left">
              {{ msg['price'] ? msg['price'][0] : ''  }}
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer class="text-center">
        <b-button size="sm" variant="danger" @click="cancel()">
		  <i class="fa fa-times-circle" aria-hidden="true"></i>
          {{$t('label.cancel')}}
        </b-button>
        <b-button size="sm" variant="success" @click="insertProduct()">
		  <i class="fa fa-check" aria-hidden="true"></i>
          {{$t('label.insert')}}
        </b-button>

      </template>
    </b-modal>
    <b-modal ref="modal-scoped-editProduct" size="lg" class="modal-aeg">
      <template #modal-header="{ close }">
        <h5 class="mb-0">{{$t('label.addNewProduct')}}</h5>
      </template>
      <template>
        <div class="row">
          <div class="col-md-6">
            <label class="require">{{$t('label.productName')}}</label>
            <b-form-input required v-model="productUpdate.productName" :placeholder="$t('label.productName')">
            </b-form-input>
            <div class="error-message w-100 clear text-left">
              {{ msg['productName'] ? msg['productName'][0] : ''  }}
            </div>
            <label class="require mt-2">{{$t('label.quantity')}}</label>
            <b-form-input type="number" required v-model="productUpdate.quantity">
            </b-form-input>
            <div class="error-message w-100 clear text-left">
              {{ msg['quantity'] ? msg['quantity'][0] : ''  }}
            </div>
            <label class="mt-2">{{$t('label.description')}}</label>
            <b-form-input size="md" type="text" v-model="productUpdate.description">
            </b-form-input>
          </div>
          <div class="col-md-6">
            <label class="require">{{$t('label.status')}}</label>
            <b-form-select v-model="productUpdate.status" :options="optionsStatus"></b-form-select>
            <div class="error-message w-100 clear text-left">
              {{ msg['status'] ? msg['status'][0] : ''  }}
            </div>
            <label class="require mt-2">{{$t('label.price')}}</label>
            <b-form-input type="number" required v-model="productUpdate.price">
            </b-form-input>
            <div class="error-message w-100 clear text-left">
              {{ msg['price'] ? msg['price'][0] : ''  }}
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer class="text-center">
        <b-button size="sm" variant="danger" @click="cancel()">
		  <i class="fa fa-times-circle" aria-hidden="true"></i>
          {{$t('label.cancel')}}
        </b-button>
        <b-button size="sm" variant="success" @click="updateProduct()">
		  <i class="fa fa-check" aria-hidden="true"></i>
          {{$t('label.save')}}
        </b-button>

      </template>
    </b-modal>
    <b-modal ref="modal-scoped-delete-product" size="lg" class="modal-aeg">
	  <template #modal-header="{ close }">
		<h5 class="mb-0">{{$t('label.deleteProductTitle')}}</h5>
	  </template>
	  <template #modal-footer class="text-center">
		<b-button size="sm" variant="danger" @click="cancelDeleteProduct()">
		  <i class="fa fa-times-circle" aria-hidden="true"></i>
		  {{$t('label.cancel')}}
		</b-button>
		<b-button size="sm" variant="success" @click="deleteProduct()">
		  <i class="fa fa-check" aria-hidden="true"></i>
		  {{$t('label.delete')}}
		</b-button>
	  </template>
	</b-modal>
    <b-modal ref="modal-scoped-convert-to-not-call" size="lg" class="modal-aeg">
      <template #modal-header="{ close }">
        <h5 class="mb-0">{{$t('label.convertToNotCall')}}</h5>
      </template>
      <template>
        <div class="row">
          <div class="col-12 text-center">
            <span>{{$t('label.confirmConvertToNotCall')}}</span>
          </div>
        </div>
      </template>
      <template #modal-footer class="text-center">
        <b-button size="sm" variant="danger" @click="cancelConvertToNotCall()">
          <i class="fa fa-times-circle" aria-hidden="true"></i>
          {{$t('label.cancel')}}
        </b-button>
        <b-button size="sm" variant="success" @click="convertToNotCall()">
          <i class="fa fa-check" aria-hidden="true"></i>
          {{$t('label.save')}}
        </b-button>

      </template>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/axios'
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      msg: [],
      idData: 0,
      dark: false,
      /*staked: true,*/
      width: 0,
      fields: [
        {
          label: this.$t('label.id'),
          key: 'id',
          sortable: true
        },
        {
          label: this.$t('label.dataName'),
          key: 'name',
          sortable: false
        },
        {
          label: this.$t('label.numberNoCall'),
          key: 'notCall',
          sortable: false
        },
        {
          label: this.$t('label.numberAgree'),
          key: 'accept',
          sortable: false
        },
        {
          label: this.$t('label.numberDeclined'),
          key: 'reject',
          sortable: false
        },
        {
          label: this.$t('label.numberDidNotPickUp'),
          key: 'notPick',
          sortable: false
        },
        {
          label: '',
          key: 'action',
          sortable: false
        }
      ],
      dataTable: [],
	    productFields: [
        {
          label: this.$t('label.id'),
          key: 'id',
          sortable: true
        },
        {
          label: this.$t('label.productName'),
          key: 'name',
          sortable: false
        },
        {
          label: this.$t('label.quantity'),
          key: 'quantity',
          sortable: false
        },
        {
          label: this.$t('label.price'),
          key: 'price',
          sortable: false
        },
        {
          label: this.$t('label.status'),
          key: 'status',
          sortable: false
        },
        {
          label: '',
          key: 'action',
          sortable: false
        }
      ],
      dataTableProduct: [],
      selected: -1,
      productUpdate: {
        id: 0,
        productName: '',
        quantity: '',
        status: -1,
        price: '',
        description: ''
      },
      dataUpdate:{
        id: 0,
        name:'',
        status: -1,
        sale_id:[]
      },
      optionsUser: [],
      dataNew: {
        dataName: '',
        status: -1
      },
      productNew: {
        productName: '',
        quantity: '',
        description:'',
        status: -1,
        price: ''
      },
      optionsStatus:[
        { value: -1, text: this.$t('label.chooseStatus')},
        { value: 0, text: this.$t('label.noActive') },
        { value: 1, text: this.$t('label.active') },
      ],
	    chartOptions: {
        chart: {
          id: 'basic-bar'
        },
        xaxis: {
          categories: ['Mobifone', 'Viettel', 'Vinaphone', this.$t('label.otherOperators'), 'Gmobile', 'Vietnammobile']
        },
		plotOptions: {
	    bar: {
		  horizontal: true,
          distributed: true
		}
	  }
      },
      series: [],
      selectedProductId: '',
      selectedDataId: ''

    }
  },
  mounted() {
    /*window.addEventListener('resize', this.handleResize)*/
    /*this.handleResize()*/
    this.getListData()
    this.getNotCallCustomer()
    this.getListProduct()
  },
  /*destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },*/
  methods: {
    loadAddNewProduct() {
      this.$refs['modal-scoped-product'].show();
    },
    async insertProduct() {
      let res;
      try {
        res = await apiClient.post('/api/v1/admin/product/insert', this.productNew)
      } catch(error) {
        if (error.response.status == 400) {
          this.msg = (error.response.data);
        } else if (error.response.status == 401) {
          alert(error.response.data)
        }
      }
      if (res && res.data) {
        this.$refs['modal-scoped-product'].hide();
        this.productNew = {
            productName: '',
            quantity: '',
            description:'',
            status: -1,
            price: ''
        },
          this.msg =  [],
          this.getListProduct();
      }
    },
    /*handleResize() {
      this.width = window.innerWidth;
      if( this.width < 768){
        this.staked = true;
      } else {
        this.staked = false;
      }
    },*/
    async getListUserSaleData() {
      this.optionsUser =  [];
      let statusKpi = -1;
      let res;
      try {
        res = await apiClient.post('/api/v1/admin/sale/list',{statusKpi: statusKpi,action:1})
      } catch(error) {
      }
      if (res && res.data) {
        res.data.sales.forEach(element =>
          this.optionsUser.push({"value": element.id, "text": element.fullName})
        );
      }
    },
    async getListData() {
      let res;
      try {
        this.$isLoading(true)
        res = await apiClient.get('/api/v1/admin/list-data-manager')
      } catch(error) {
      } finally {
        this.$isLoading(false)
      }
      if (res && res.data) {
        this.dataTable = res.data;
      }
    },
	async getListProduct() {
      let res;
      try {
        res = await apiClient.get('/api/v1/admin/product/list')
      } catch(error) {
      }
      if (res && res.data) {
        this.dataTableProduct = res.data;
      }
    },
    loadAddNew() {
      this.$refs['modal-scoped'].show();
    },
    cancel(){
      this.productNew = {
        productName: '',
        quantity: '',
        description: '',
        status: -1,
        price: ''
      },
      this.$refs['modal-scoped-edit'].hide();
      this.$refs['modal-scoped'].hide();
      this.$refs['modal-scoped-product'].hide();
      this.$refs['modal-scoped-editProduct'].hide();
      this.dataNew = {
        username: '',
        password: '',
        rePassword: '',
        fullName: '',
        userType:-1,
        status: -1,
        operator: [],
        dataLimit: [],
        productLimit: [],
      },
        this.msg =  []
    },
    editData(id) {
      this.getDataById(id);
      this.$refs['modal-scoped-edit'].show();
      this.getListUserSaleData();
    },
    editProduct(id) {
      this.getProductById(id);
      this.$refs['modal-scoped-editProduct'].show();
      this.getListUserSaleData();
    },
    async getProductById(id) {
      let res;
      try {
        res = await apiClient.get('/api/v1/admin/product/' + id)
      } catch(error) {
        if (error.response.status == 400) {
          this.msg = (error.response.data);
        } else if (error.response.status == 401) {
          alert(error.response.data)
        }
      }
      if (res && res.data) {
        this.productUpdate = {
          productName: '',
          quantity: '',
          status: -1,
          description: '',
          price: ''
        },
          this.productUpdate.id = res.data.id;
          this.productUpdate.productName = res.data.name;
          this.productUpdate.status = res.data.status;
          this.productUpdate.quantity = res.data.quantity;
          this.productUpdate.price = res.data.price;
          this.productUpdate.description = res.data.description
      }
    },
    async getDataById(id) {
      let res;
      try {
        res = await apiClient.get('/api/v1/admin/data/' + id)
      } catch(error) {
        if (error.response.status == 400) {
          this.msg = (error.response.data);
        } else if (error.response.status == 401) {
          alert(error.response.data)
        }
      }
      if (res && res.data) {
        this.dataUpdate = {
            id: id,
            name: '',
            status: -1,
            sale_id: []
        },
        this.dataUpdate.name = res.data[0].name;
        this.dataUpdate.status = res.data[0].status;
        if(res.data[0].sale_id != null && res.data[0].sale_id != ''){
          this.dataUpdate.sale_id = res.data[0].sale_id.split(', ');
        }
      }
    },
    async insertData() {
      let res;
      try {
        res = await apiClient.post('/api/v1/admin/data/insert', this.dataNew)
      } catch(error) {
        if (error.response.status == 400) {
          this.msg = (error.response.data);
        } else if (error.response.status == 401) {
          alert(error.response.data)
        }
      }
      if (res && res.data) {
        this.$refs['modal-scoped'].hide();
        this.dataNew = {
          username: '',
          status: -1
        }
        this.msg =  []
        this.getListData()
      }
    },
    async updateProduct() {
      let res;
      try {
        res = await apiClient.post('/api/v1/admin/product/update', this.productUpdate)
      } catch(error) {
        if (error.response.status == 400) {
          this.msg = (error.response.data);
        }
      }

      if (res && res.data) {
        this.$refs['modal-scoped-editProduct'].hide();
        this.getListUserSaleData();
        this.$bvToast.toast(res.data, {
          title: this.$t('label.info'),
          toaster: 'b-toaster-top-right',
          variant: 'primary',
          solid: true,
          appendToast: true
        })
		this.msg = []
		this.getListProduct()
      }
    },
    async updateData() {
      let res;
      try {
	    this.$isLoading(true)
        res = await apiClient.post('/api/v1/admin/data/update', this.dataUpdate)
      } catch(error) {
        if (error.response.status == 400) {
		      this.$isLoading(false)
          this.msg = (error.response.data)
        }
		    return
      } finally {
	      this.$isLoading(false)
	    }

      if (res && res.data) {
        this.msg =  []
        this.$refs['modal-scoped-edit'].hide()
        this.getListData()
        this.getNotCallCustomer()
        this.$bvToast.toast(res.data, {
          title: this.$t('label.info'),
          toaster: 'b-toaster-top-right',
          variant: 'primary',
          solid: true,
          appendToast: true
        })
      }
    },
	async getNotCallCustomer() {
      let res
      try {
	    this.$isLoading(true)
        res = await apiClient.get('/api/v1/admin/customer/counting/nocall')
      } catch(error) {
      } finally {
	    this.$isLoading(false)
	  }
      if (res && res.data) {
	    let data = new Array(res.data.mobifoneCount, res.data.viettelCount, res.data.vinaphoneCount, res.data.otherCount, res.data.gMobileCount, res.data.vietnamMobileCount)
	    //let chartSeries = {data: data}
	    //this.series.push(chartSeries)
		this.$refs.chart1.updateSeries([{
           data: data
        }])
      }
    },
	openDeleteProductModal(id) {
	  this.selectedProductId = id
	  this.$refs['modal-scoped-delete-product'].show();
	},
	cancelDeleteProduct() {
	  this.$refs['modal-scoped-delete-product'].hide();
	},
	async deleteProduct(id) {
	  let res
      try {
        res = await apiClient.put('/api/v1/admin/product/delete/' + this.selectedProductId)
      } catch(error) {
      }
      if (res && res.data) {
	      this.cancelDeleteProduct()
		    this.getListProduct()
		    this.$bvToast.toast(res.data, {
          title: this.$t('label.info'),
          toaster: 'b-toaster-top-right',
          variant: 'primary',
          solid: true,
          appendToast: true
        })
      }
	  },
    openConvertToNotCall(id) {
      this.selectedDataId = id
      this.$refs['modal-scoped-convert-to-not-call'].show();
    },
    cancelConvertToNotCall() {
      this.selectedDataId = ''
      this.$refs['modal-scoped-convert-to-not-call'].hide();
    },
    async convertToNotCall() {
      let res
      try {
        this.$isLoading(true)
        res = await apiClient.post('/api/v1/admin/data/convert-to-not-call', {
            "dataId": this.selectedDataId
          }
        )
      } catch(error) {
      } finally {
        this.$isLoading(false)
      }
      if (res && res.data) {
        this.getListData()
        this.selectedDataId = ''
        this.$refs['modal-scoped-convert-to-not-call'].hide();
        this.$bvToast.toast(res.data, {
          title: this.$t('label.info'),
          toaster: 'b-toaster-top-right',
          variant: 'primary',
          solid: true,
          appendToast: true
        })
      }
    }
  }
}
</script>
<style lang="stylus">
  .wrap-chart{
    max-width 500px;
  }
  .data-section {
    .active {
	  color: #28a745
	}
	.no-active {
	  color: #ff4560
	}
  }
  .product-section {
    .active {
	  color: #28a745
	}
	.no-active {
	  color: #ff4560
	}
  }
</style>
